export default __webpack_public_path__ + "static/media/heart.8ccf31b2.svg";